import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import Budget from '../../../widgets/budget/Budget'
import { getSchemaPaymentSave } from '../../../redux/actions/paymentSave'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function PaymentSave() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaPaymentSave(projectId)
      setSchema(_schema.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.forms?.projectInfo} />
      <br />
      <Budget
        schema={schema.forms}
        isEditable={true}
        isEditableBudgetPlan={true}
        isEditableBudgetInstallmentPlan={true}
      />
      <br />
    </SidebarProposal>
  )
}
